const errorCodes = {
  UserAccountExpiredException: 52,
  TokenMalformedException: 61,
  TokenExpiredException: 62,
  TokenInvalidException: 63,
  InvalidRequestDataException: 102,
  InvalidBusinessProfileRequested: 112,
  ForbiddenBusinessProfileRequested: 113,
  ForbiddenPortalRequested: 56,
  Unauthorized: 401,
  Forbidden: 403,
  RefreshTokenExpired: 76
};

export default errorCodes;
